module.exports = __webpack_public_path__ + "decbfaa015d7a842f42b85e2af388350.svg";